import React, { useState } from 'react';
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const faqs = [{
    question: '¿Qué formato tiene? ¿Cómo recibo el ebook?',
    answer: 'El ebook está en formato PDF de alta calidad, optimizado para verse bien en cualquier dispositivo. Inmediatamente después de tu compra, recibirás un email con el enlace de descarga directa.'
  }, {
    question: '¿Necesito experiencia previa?',
    answer: 'No, en absoluto. La guía está diseñada para principiantes, con instrucciones paso a paso muy claras y simples. Todo está explicado de manera que cualquier persona pueda seguirlo sin dificultad.'
  }, {
    question: '¿Funciona si vivo en departamento/casa pequeña?',
    answer: '¡Sí! Los rituales están adaptados para cualquier tipo de hogar, sin importar el tamaño. Hemos incluido variaciones específicas para espacios pequeños y apartamentos.'
  }, {
    question: '¿Cuánto tiempo debo dedicar por día?',
    answer: 'Solo necesitas entre 10 y 20 minutos diarios para realizar los rituales. Están diseñados para integrarse fácilmente en tu rutina, incluso si tienes un horario muy ocupado.'
  }, {
    question: '¿Puedo aplicarlo a mis hijos?',
    answer: 'Definitivamente. La guía incluye oraciones y rituales específicos para proteger a los niños, con instrucciones especiales para madres sobre cómo extender la protección a toda la familia.'
  }, {
    question: '¿Qué pasa si no noto cambios?',
    answer: 'Si después de seguir el plan completo de 7 días no percibes ningún cambio en tu energía o en tu hogar, puedes solicitar un reembolso completo. Nuestra garantía de 7 días te protege.'
  }, {
    question: '¿Necesito comprar elementos costosos?',
    answer: 'No. Todos los ingredientes y elementos necesarios son comunes y económicos. La mayoría probablemente ya los tengas en casa, y si no, se pueden conseguir fácilmente en cualquier tienda o supermercado.'
  }];
  return <section className="py-12 px-4 sm:px-6 md:px-8 max-w-7xl mx-auto" data-id="element-110">
      <div className="max-w-3xl mx-auto" data-id="element-111">
        <h2 className="font-serif text-2xl sm:text-3xl font-bold text-center text-[#0C1B2A] mb-12" data-id="element-112">
          Preguntas frecuentes
        </h2>
        <div className="space-y-4" data-id="element-113">
          {faqs.map((faq, index) => <div key={index} className="border border-[#E8DFD3] rounded-lg overflow-hidden" data-id="element-114">
              <button className={`w-full text-left px-6 py-4 flex justify-between items-center focus:outline-none ${openIndex === index ? 'bg-[#F8F2EA]' : 'bg-white'}`} onClick={() => toggleFAQ(index)} aria-expanded={openIndex === index} aria-controls={`faq-answer-${index}`} data-id="element-115">
                <span className="font-serif font-semibold text-[#0C1B2A]" data-id="element-116">
                  {faq.question}
                </span>
                <svg className={`w-5 h-5 text-[#0C1B2A] transition-transform duration-300 ${openIndex === index ? 'transform rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-117">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" data-id="element-118" />
                </svg>
              </button>
              <div id={`faq-answer-${index}`} className={`px-6 py-4 bg-white transition-all duration-300 ${openIndex === index ? 'block' : 'hidden'}`} data-id="element-119">
                <p className="text-[#555555]" data-id="element-120">{faq.answer}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};